import AntdTables, { ColumnTypes } from '@/@core/components/tables-antd'
import {
  fetchRohList,
  GeneImprint,
  getGlsRoh,
  IVariantRohData,
  IVariantRohList
} from '@/@core/services/app.service'
import { calculateCoverage, cleanAllele } from '@/@core/utils/utils'
import { chromSizes } from '@/pages/samples/SampleTabs/[id]'
import {
  Typography,
  Stack,
  Tooltip,
  Grid,
  CardContent,
  Card,
  Box
} from '@mui/material'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  hlaData: any[]
  analysisInfo: any
}

const HLAChild = (props: Props) => {
  const { hlaData } = props
  const { t, i18n } = useTranslation()
  const hlaColumns: GridColDef[] = [
    {
      field: 'gene',
      renderHeader: () => <Typography>{t('gene')}</Typography>,
      minWidth: 120,
      sortable: false
    },
    {
      field: 'allele_1',
      renderHeader: () => <Typography>allele_1</Typography>,
      minWidth: 240,
      sortable: false
    },
    {
      field: 'allele_2',
      renderHeader: () => <Typography>allele_2</Typography>,
      minWidth: 240,
      sortable: false
    },
    {
      field: 'quality_1',
      renderHeader: () => <Typography>quality_1</Typography>,
      minWidth: 80,
      sortable: false
    },
    {
      field: 'quality_2',
      renderHeader: () => <Typography>quality_2</Typography>,
      minWidth: 80,
      sortable: false
    },
    {
      field: 'hla_class',
      renderHeader: () => <Typography>hla_class</Typography>,
      minWidth: 80,
      sortable: false
    }
  ]

  const data = React.useMemo(() => {
    if (!Array.isArray(hlaData)) return []

    return hlaData.map((item) => ({
      ...item, // 保留其他所有字段
      allele_1: cleanAllele(item.allele_1),
      allele_2: cleanAllele(item.allele_2)
    }))
  }, [hlaData])
  return (
    <Grid
      container
      spacing={4}
      overflow="auto"
      maxHeight={'800px'}
      marginTop={4}
    >
      <Grid item xs={12} md={12}>
        <Card sx={{ width: '100%', height: '600px' }}>
          <CardContent sx={{ height: '100%' }}>
            <Typography>{t('HLA gene data:')}</Typography>

            <DataGrid
              rows={data}
              columns={hlaColumns}
              hideFooter={true}
              disableRowSelectionOnClick
              disableColumnMenu
              sx={{
                height: 500,
                '& .MuiDataGrid-columnHeaders': {
                  bgcolor: '#EDEFF0'
                }
              }}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default HLAChild
